import * as React from "react";
import {useMain} from "../../../../Utils/SessionControls/mainContext";
import OdxModal from '../../../../OdxComponents/NativeOdx/Modal/Odx-Modal';
import {UpdateAccessRoles} from "../../../Hub/BackendFacade/apiCalls";
import {IIdmsUserUpdateBody, IUserData} from "../../Interfaces/IUsers";
import {getIdFromUserObject, isIdmsModuleMode, simplifyForHtmlId} from "../../../../Utils/transformer";
import {sendUsersEditDataCall} from "../../BackendFacade/apiCalls";
import {HubPathRouting} from "../../../../HubFramework/pathBuilder";
import {ITinyUser} from "../../Interfaces/interfaces";
import {IValueContainer} from "../../../../Utils/IValueContainer";

interface IProps {
    onSuccessFunction: () => void;
    closeFunction: () => void;
    userData: IUserData;
    currentProject: string;
    hubOrIdms: string;
}

const User_Delete: React.FC<IProps> = ({closeFunction, onSuccessFunction, userData, currentProject, hubOrIdms}) => {
    const {setLoading, createToast, createErrorToast} = useMain();
    const modalNamespace = hubOrIdms?.toLowerCase() ?? 'hub';
    const userKey = simplifyForHtmlId(getIdFromUserObject(userData, isIdmsModuleMode(hubOrIdms)) || userData.mail || 'user');
    const baseId = `${modalNamespace}-user-delete-${userKey}`;

    const applyDelete = () => {
        setLoading(true);

        if (isIdmsModuleMode(hubOrIdms)) {
            // idms
            const apiBody : IValueContainer<IIdmsUserUpdateBody[]> = {
                Value:
                    [{
                        id: getIdFromUserObject(userData, isIdmsModuleMode(hubOrIdms)),
                        newValue: null
                    }]
            }

            sendUsersEditDataCall(HubPathRouting.currentProject.id, HubPathRouting.currentModule.id, apiBody).then(async (data) => {
                if (!data.success) {
                    createErrorToast(data.message as string);
                } else {
                    createToast({message: "User deleted successfully", variant: "success", title: "Success"});
                    onSuccessFunction();
                    closeFunction();
                }
                setLoading(false);
            });

        } else {
            // hub
            UpdateAccessRoles(getIdFromUserObject(userData, isIdmsModuleMode(hubOrIdms)), {}, currentProject).then(async (data) => {
                if (!data.success) {
                    createErrorToast(data.message as string);
                } else {
                    createToast({message: "User deleted successfully", variant: "success", title: "Success"});
                    onSuccessFunction();
                    closeFunction();
                }
                setLoading(false);
            });
        }
    };

    return (
        <OdxModal
            size={"medium"}
            title={`Delete user?`}
            onClose={closeFunction}
            footerButtons={[
                <odx-button
                    key="cancel"
                    id={`${baseId}-cancel-btn`}
                    variant="neutral"
                    size="lg"
                    type="button"
                    onClick={closeFunction}
                >
                    Cancel
                </odx-button>,
                <odx-button
                    key="delete"
                    id={`${baseId}-confirm-btn`}
                    variant="danger"
                    size="lg"
                    type="button"
                    onClick={applyDelete}
                >
                    Delete
                </odx-button>
            ]}
            isOpen={true}
            variant={"default"}
            zIndex={1000}
            id={baseId}
        >
            <div id={`${baseId}-message`}>Are you sure you want to delete the user {userData.mail || userData.userId}?</div>
        </OdxModal>
    );
};

export default User_Delete;
